import { SCENE_EVENTS } from "../MVC/Model";

const languageItem = (language, lngTxt) => {
  return `
  <li class='language-option clickable' data-lang='${language}'>
    <div>
      <span class='language-description' data-lang='${language}'>${lngTxt}</span>
    </div>
  </li> 
  `;
};

class LanguageMenu {
  constructor({ model }) {
    this.model = model;
    this.init();
  }

  init() {
    const model = this.model;

    // Create and append the language menu to the document
    $(".language-menu-dropdown").append(LanguageMenu.template());

    // Handle click outside to close menu
    $(document).on("click", (e) => {
      if (!$(e.target).hasClass('world-top-nav__menu_area') && !$(e.target).closest('.world-top-nav__menu_area').length) {
        LanguageMenu.toggle(true, model);
      }
    });

    // Handle language selection
    $('#language-menu').on('click', '.language-option', (e) => {
      const language = $(e.currentTarget).data('lang');
      if (language) {
        multiLanguagesController.changeLanguage(language);
        LanguageMenu.toggle(true, model);
        $('.language-option').removeClass("active");
        $(`.language-option[data-lang=${language}]`).addClass("active");
      }
    });

    // Prevent menu from closing when clicking inside
    $('#language-menu').on('click', (e) => {
      e.stopPropagation();
    });

    this.initChangeLanguage();
    this.addLanguageMenuListeners();
  }

  addLanguageMenuListeners() {
    this.model.addEventListener(SCENE_EVENTS.PROFILE_MENU_OPEN, () => {
      LanguageMenu.toggle(true, this.model);
    });
  }

  initChangeLanguage() {
    const change_language = $(".app-change-language");
    multiLanguagesController.supportedLanguages.forEach(language => {
      const lngTxt = multiLanguagesController.languageObject.hasOwnProperty(language) ? multiLanguagesController.languageObject[language].text : multiLanguagesController.languages[language].languageName;
      change_language.append(languageItem(language, lngTxt));
    });

    change_language.on('change', (e) => {
      $(".change_language > .select-selected").attr("data-lang", e.target.value);
      multiLanguagesController.changeLanguage(e.target.value);
    });

  }

  static toggle(close, model) {
    const $dropdown = $("#language-menu");
    if (close) {
      $dropdown.removeClass("is-active");
    } else {
      $dropdown.toggleClass('is-active');
    }
    if (close) {
      model.dispatchEvent({ type: SCENE_EVENTS.LANGUAGE_MENU_CLOSE });
    } else {
      model.dispatchEvent({ type: SCENE_EVENTS.LANGUAGE_MENU_OPEN });
    }
  }

  static template() {
    return `
      <ul class='bagless-dropdown-menu app-change-language' id='language-menu'>
      </ul>
    `;
  }
}

export default LanguageMenu;
